import styled from 'styled-components';
import { Header3, Header4, P2 } from '../Typography';

// The layout of the admin details modals (manual payment, response deadline): label/value rows grouped in sections.

export const SECTION_GAP = '36px';

export const ModalHeader = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin-bottom: 30px;
`;

export const CloseButton = styled.button`
  background: transparent;
  border: none;
  color: ${(props) => props.theme.colors.body2};
  cursor: pointer;
  font-size: 28px;
  line-height: 1;
  outline: none;
`;

export const DetailTable = styled.div`
  border-top: 1px solid ${(props) => props.theme.colors.dividerLight};
`;

export const TwoColumnDetailTable = styled(DetailTable)`
  display: grid;
  grid-column-gap: ${SECTION_GAP};
  grid-template-columns: repeat(auto-fit, minmax(340px, 1fr));
`;

export const DetailTableRow = styled.div`
  align-items: center;
  border-bottom: 1px solid ${(props) => props.theme.colors.dividerLight};
  display: flex;
  justify-content: space-between;
  min-height: 32px;
  padding: 4px 0;
`;

export const DetailLabel = styled(P2)`
  flex: 0 0 32%;
  margin-bottom: 0;
  min-width: 0;
  padding-right: 16px;
`;

export const DetailValue = styled.span`
  color: ${(props) => props.theme.colors.body};
  font-family: ${(props) => props.theme.typography.face.secondary};
  font-size: 15px;
  font-weight: bold;
  line-height: 1.45;
  max-width: 68%;
  text-align: right;
  word-break: break-word;
`;

export const SectionTitle = styled(Header4)`
  margin-bottom: 12px;
`;

export const ModalTitle = styled(Header3)`
  margin-bottom: 0;
`;

export const SectionPanel = styled.div`
  background: ${(props) => props.theme.colors.bgAccent};
  border: 1px solid ${(props) => props.theme.colors.dividerLight};
  border-radius: 6px;
  padding: 18px 20px 20px;

  ${DetailTable} {
    border-top: none;
  }

  ${DetailTableRow}:last-child {
    border-bottom: none;
  }
`;
